<template>
  <a-modal
    title="ASN单维护"
    v-model="visible"
    okText="关闭"
    cancelText="取消"
    :dialogStyle="{ top: '20px', verticalAlign: 'top', height: '90%' }"
    width="95%"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <!--     :bodyStyle="{ height: '90%' }" -->
    <div>
      <a-card :bordered="false">
        <a-form :form="form">
          <a-form-item label v-show="false">
            <a-input v-decorator="['id', { rules: [] }]" />
            <a-input v-decorator="['cbustype', { rules: [] }]" />
            <a-input v-decorator="['cptcode', { rules: [] }]" />
            <a-input v-decorator="['csccode', { rules: [] }]" />
            <a-input v-decorator="['itaxrate', { rules: [] }]" />
            <a-input v-decorator="['cexch_name', { rules: [] }]" />
            <a-input v-decorator="['iexchrate', { rules: [] }]" />
            <a-input v-decorator="['cdepcode', { rules: [] }]" />
            <a-input v-decorator="['cpersoncode', { rules: [] }]" />
          </a-form-item>
          <a-row :gutter="24">
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="ASN单号">
                <a-input placeholder="ASN单号" v-decorator="['ccode']" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商编码">
                <a-input placeholder="供应商编码" v-decorator="['cvencode']" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商名称">
                <a-input placeholder="供应商名称" v-decorator="['cvenname']" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据日期">
                <a-date-picker placeholder="单据日期" v-decorator="['ddate', { rules: [{ type: 'object' }] }]" :disabled="true" style="width: 100%" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到货地址">
                <a-input placeholder="到货地址" v-decorator="['carrivalplace']" style="width: 100%" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="到货方式">
                <a-input placeholder="到货方式" v-decorator="['cscname']" style="width: 100%" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
                <a-input placeholder="联系人" v-decorator="['asnperson']" style="width: 100%" :disabled="true" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话">
                <a-input placeholder="电话" v-decorator="['asnphone']" style="width: 100%" :disabled="true" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
                <a-date-picker placeholder="发货日期" v-decorator="['dshipdate']" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="6">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预计到货日期">
                <a-date-picker placeholder="预计到货日期" v-decorator="['darridate']" style="width: 100%" />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :sm="12">
              <a-form-item :labelCol="{ xs: { span: 24 }, sm: { span: 3 } }" :wrapperCol="{ xs: { span: 24 }, sm: { span: 21 } }" label="备注">
                <a-input placeholder="备注" v-decorator="['cmemo']" style="width: 100%" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24"> </a-row>
          <a-row>
            <a-button-group style="float:left;margin-bottom:10px">
              <a-button icon="printer" @click="toPrint">打印单据</a-button>
              <a-popconfirm title="是否确定删除单据?" ok-text="确定" cancel-text="取消" @confirm="toDeleteASN">
                <a-button icon="delete" v-if="$route.meta.removeASN">删除单据</a-button>
              </a-popconfirm>

              <a-button icon="edit" @click="toEdit" :disabled="!isAsnFlag">修改</a-button>
              <!-- <a-popconfirm title="是否确定删行?" ok-text="确定" cancel-text="取消" @confirm="toDelete">
                <a-button icon="delete" v-if="(userinfo.cvencode ? true : false) && isAsnFlag">删行</a-button>
              </a-popconfirm> -->
              <a-button icon="undo" @click="toGiveUp">放弃</a-button>
              <!-- <a-button icon="qrcode" @click="toGetCode">生成条码</a-button> -->
              <a-button icon="printer" @click="toPrintCode">打印条码</a-button>
              <a-button
                icon="save"
                v-if="(type==='ASN单生成'&&$route.meta.saveASN )"
                :disabled="!isAsnFlag"
                @click="toSave"
                >保存</a-button
              >
              <a-button
                icon="save"
                v-if="(type==='ASN单列表'&&$route.meta.updateAsnInfo)"
                :disabled="!isAsnFlag"
                @click="toSave"
                >保存</a-button
              >
            </a-button-group>
          </a-row>
          <uto-table-new
            :columns="columns"
            :dataSource="dataSource"
            bordered
            :pagination="false"
            :customRow="rowClick"
            :rowSelection="{ onChange: onSelectChange, selectedRowKeys: selectedRowKeys }"
            rowKey="autoid"
          >
            <div slot="fileT" slot-scope="flag, record, index">
              <a @click.stop="toPreview(record, index)">{{ displayName(record) }}</a>
            </div>
            <div slot="actionT" slot-scope="flag, record, index">
              <span v-if="$route.meta.cbarcode">
                <a @click.stop="toCreate(record)">生成条码</a>
                <a-divider type="vertical"></a-divider>
              </span>
              <!-- :disabled="!record.bbarcode" -->
              <!-- <span v-if="$route.meta.sbarcode">
                <a @click.stop="toSelect(record)">选择条码</a>
                <a-divider type="vertical"></a-divider>
              </span> -->
              <a-popconfirm title="是否确定删行?" ok-text="确定" cancel-text="取消" @confirm="toDelete(record, index)">
                <a>删除</a>
              </a-popconfirm>
            </div>
            <div slot="darridateR" slot-scope="flag">{{ date2string(flag) }}</div>
            <div slot="dpdateR" slot-scope="text, record, index">
              <a-date-picker
                v-if="isEdit"
                :value="record.binvquality ? (record.dpdate ? moment(record.dpdate) : moment()) : null"
                :disabled="!record.binvquality ? true : false"
                @change="e => handleChange(e, record, 'dpdate', index)"
              />
              <span v-else> {{ date2string(text) }}</span>

              <!-- <a-date-picker style="margin: -5px 0" :value="text ? moment(text) : null" @change="e => handleChange(e, record, 'dpdate', index)" /> -->
            </div>
            <template slot="iquantityR" slot-scope="text, record, index">
              <a-input-number
                v-if="isEdit"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e, record, 'iquantity', index)"
                :min="0"
              />
              <span v-else> {{ text }}</span>
            </template>
            <template slot="cbatchT" slot-scope="text, record, index">
              <a-input
                v-if="isEdit"
                :disabled="!record.binvbatch"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record, 'cbatch', index)"
              />
              <span v-else> {{ text }}</span>
            </template>
            <template slot="memoR" slot-scope="text, record, index">
              <a-textarea
                v-if="isEdit"
                style="margin: -5px 0"
                :value="text"
                @change="e => handleChange(e.target.value, record, 'cmemo', index)"
              ></a-textarea>
              <span v-else> {{ text }}</span>
            </template>
            <div slot="dvdateR" slot-scope="flag">{{ date2string(flag) }}</div>
          </uto-table-new>
          <a-divider>条码明细</a-divider>
          <div style="margin-bottom:10px">
            <a-popconfirm title="是否确定删除?" ok-text="确定" cancel-text="取消" @confirm="toBatachDelete">
              <a-button type="" style="margin-right:5px">批量删除</a-button>
            </a-popconfirm>
            <a-button type="" @click="toBatchPrint">批量打印条码</a-button>
          </div>
          <uto-table-new
            :columns="columns2"
            :loadParams="loadParams2"
            :url="queryUrl2"
            :conditions="conditions2"
            bordered
            ref="utn2"
            rowKey="barcode"
            :rowSelection="{ onChange: onSelectChange2, selectedRowKeys: selectedRowKeys2 }"
          >
            <div slot="actionT" slot-scope="flag, record">
              <a-popconfirm title="确认删除?" @confirm="() => toDelete2(record)">
                <a>删除</a>
              </a-popconfirm>

              <a-divider type="vertical"></a-divider>
              <a @click="toPrint2(record)">打印</a>
            </div>
            <div slot="ddateR" slot-scope="flag">{{ date2string(flag) }}</div>
          </uto-table-new>
        </a-form>
      </a-card>
    </div>
    <a-s-n-code ref="asncode" @success="toQuery"></a-s-n-code>
    <a-s-n-code-print ref="asncodeprint"></a-s-n-code-print>
    <a-s-n-upload ref="preview" @success="uploadData"></a-s-n-upload>
    <create-barcode ref="create" @success="getBodyData"></create-barcode>
  </a-modal>
</template>
<script>
import utoPrint from '../../../../utils/print/utoprint'
import { scmApi, updateAsnInfo, getASNByCCode, deleteAsnMain, delRowASN, needUpload, asndelBarcode, queryBOverPO } from '@/api/scmApi'
import CreateBarcode from './CreateBarcode.vue'
import moment from 'moment'
import ASNCode from './ASNCode'
import ASNCodePrint from './ASNCodePrint'
import ASNUpload from './ASNUpload'
export default {
  name: 'ASNDetailNew',
  components: {
    ASNCode,
    ASNCodePrint,
    ASNUpload,
    CreateBarcode
  },
  data() {
    return {
      isAsnFlag: null,
      visible: false,
      form: this.$form.createForm(this),
      userinfo: this.$store.getters.userinfo,
      U8UserInfo: this.$store.getters.U8UserInfo,
      labelCol: { xs: { span: 24 }, sm: { span: 7 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 17 } },
      fileName: '',
      columns: [
        {
          title: '操作',
          width: 130,
          scopedSlots: { customRender: 'actionT' }
        },
        {
          title: '附件',
          width: 160,
          scopedSlots: { customRender: 'fileT' }
        },

        {
          title: '存货编码',
          dataIndex: 'cinvcode',
          width: 120
        },
        {
          title: '存货名称',
          dataIndex: 'cinvname',
          width: 150
        },
        {
          title: '主计量单位',
          dataIndex: 'cinvm_unit',
          width: 100
        },
        {
          title: '待发货数量',
          dataIndex: 'foutquantity',
          width: 100
        },
        {
          title: '本次发货数量',
          dataIndex: 'iquantity',
          width: 110,
          scopedSlots: { customRender: 'iquantityR' }
        },

        {
          title: '批号',
          dataIndex: 'cbatch',
          width: 140,
          scopedSlots: { customRender: 'cbatchT' }
        },
        {
          title: '生产日期',
          dataIndex: 'dpdate',
          width: 130,
          scopedSlots: { customRender: 'dpdateR' }
        },
        {
          title: '备注',
          dataIndex: 'cmemo',
          width: 200,
          scopedSlots: { customRender: 'memoR' }
        },
        {
          title: '存货代码',
          dataIndex: 'cinvaddcode',
          width: 120
        },
        {
          title: '规格型号',
          dataIndex: 'cinvstd',
          width: 180
        },
        {
          title: '采购订单号',
          dataIndex: 'cordercode',
          width: 120
        },
        {
          title: '订单数量',
          dataIndex: 'ipoquantity',
          width: 100
        },
        {
          title: '已到货数量',
          dataIndex: 'farrqty',
          width: 100
        },
        {
          title: '未到货数量',
          dataIndex: 'wdhsl',
          width: 100
        },
        {
          title: '已接收数量',
          dataIndex: 'frealquantity',
          width: 90
        },

        {
          title: '仓库编码',
          dataIndex: 'cwhcode',
          width: 90
        },
        {
          title: '仓库名称',
          dataIndex: 'cwhname',
          width: 120
        },
        {
          title: '失效日期',
          dataIndex: 'dvdate',
          width: 130,
          scopedSlots: { customRender: 'dvdateR' }
        },
        {
          title: '预到货日期',
          dataIndex: 'darridateb',
          scopedSlots: { customRender: 'darridateR' },
          width: 110
        },
        {
          title: '物料自由项1',
          dataIndex: 'cfree1',
          width: 120
        },
        {
          title: '物料自由项2',
          dataIndex: 'cfree2',
          width: 120
        },
        {
          title: '物料自由项3',
          dataIndex: 'cfree3',
          width: 120
        },
        {
          title: '物料自由项4',
          dataIndex: 'cfree4',
          width: 120
        },
        {
          title: '物料自由项5',
          dataIndex: 'cfree5',
          width: 120
        },
        {
          title: '物料自由项6',
          dataIndex: 'cfree6',
          width: 120
        },
        {
          title: '物料自由项7',
          dataIndex: 'cfree7',
          width: 120
        },
        {
          title: '物料自由项8',
          dataIndex: 'cfree8',
          width: 120
        },
        {
          title: '物料自由项9',
          dataIndex: 'cfree9',
          width: 120
        },
        {
          title: '物料自由项10',
          dataIndex: 'cfree10',
          width: 120
        }
      ],
      dataSource: [],
      formData: {},
      selectedRowKeys: [],
      selectedRows: [],
      issaved: false,
      id: null,
      isdetail: false,
      ccode: '',
      columns2: [
        {
          title: '操作',
          width: 120,
          scopedSlots: { customRender: 'actionT' }
        },
        {
          title: '条码',
          dataIndex: 'barcode',
          width: 120,
          align: 'center'
        },
        {
          title: 'ASN单',
          dataIndex: 'csrccode',
          width: 140
        },
        {
          title: '存货编码',
          dataIndex: 'cinvcode',
          width: 140
        },
        // {
        //   title: '批号',
        //   dataIndex: 'cbatch',
        //   width: 140
        // },
        {
          title: '数量',
          dataIndex: 'qty',
          width: 140
        },
        {
          title: '条码规则',
          dataIndex: 'barcoderulename',
          width: 140
        }
        // {
        //   title: '标签',
        //   dataIndex: '22',
        //   width: 140
        // }
      ],
      conditions2: {
        csrccode: 'like_anywhere',
        csrcsubid: 'like_anywhere'
      },
      loadParams2: {},
      queryUrl2: '',
      selectedRows: [],
      loading: false,
      selectedRowKeys2: [],
      selectedRows2: [],
      isEdit: false,
      asnInfo: null, //接口中查询所得的表头信息,
      isCddfh: false,
      type:'',        //区分asn单列表还是asn生成
    }
  },
  mounted() {
    console.log(this.$route.meta,'路由00000000000')
    queryBOverPO()
      .then(res => {
        if (String(res.code) === '0') {
          if (res.data[0].cvalue == 'True') {
            this.isCddfh = true
          } else {
            this.isCddfh = false
          }
        } else {
          this.$message.error('数据获取失败，请稍后重试')
        }
      })
      .catch(err => {
        this.$message.error('数据获取失败，请稍后重试')
      })
  },
  methods: {
    toEdit() {
      this.isEdit = true
    },
    toCreate(record) {
      this.$refs.create.toGetCode(this.ccode, record)
    },
    // toSelect(record) {
    //   this.$refs.select.toOpen(this.asnInfo, record)
    // },
    // toImportBarcode() {
    //   this.$refs.import.toOpen(this.asnInfo)
    // },
    rowClick(record) {
      const that = this
      return {
        style: {
          cursor: 'pointer'
        },
        on: {
          click: () => {
            that.rowInfo = record
            that.loadParams2['csrccode'] = that.ccode
            that.loadParams2['csrcsubid'] = record.autoid
            that.queryUrl2 = scmApi.queryPagerBarCodes + '?t=' + parseInt(Math.random() * 1000)
          }
        }
      }
    },
    // 获取和刷新条码明细
    getBodyData() {
      this.loadParams2['csrccode'] = this.ccode
      this.loadParams2['csrcsubid'] = this.rowInfo.autoid
      this.queryUrl2 = scmApi.queryPagerBarCodes + '?t=' + parseInt(Math.random() * 1000)
    },
    //批量删除
    toBatachDelete() {
      const that = this
      if (that.selectedRowKeys2.length > 0) {
        const barcodes = that.selectedRowKeys2.join()
        asndelBarcode({ autoid: this.rowInfo.autoid, barcode: barcodes })
          .then(res => {
            if (res.code == 0) {
              that.$message.success('批量删除成功！')
              that.getBodyData()
            } else {
              that.$message.error(res.msg ? res.msg : '删除失败，请联系管理员')
            }
          })
          .catch(() => {
            that.$message.error('删除失败，请重试！')
          })
      } else {
        that.$message.warning('请先选择需要删除的行!')
      }
    },
    // 删除条码明细
    toDelete2(record) {
      const that = this
      asndelBarcode({ autoid: this.rowInfo.autoid, barcode: record.barcode })
        .then(res => {
          if (res.code == 0) {
            that.$message.success('删除成功！')
            that.getBodyData(record)
          } else {
            that.$message.error(res.msg ? res.msg : '删除失败，请重试！')
          }
        })
        .catch(() => {
          that.$message.error(res.msg ? res.msg : '删除失败，请重试！')
        })
    },
    // 条码明细表体打印
    toPrint2(record) {
      this.$refs.asncodeprint.toBatchPrint(this.asnInfo.ccode, record.cinvcode, [{ ...record }])
    },
    // 条码明细批量打印
    toBatchPrint() {
      const _that = this
      let cinvcode = ''
      _that.selectedRows2.map(curr => {
        cinvcode = cinvcode + curr.cinvcode + ','
      })
      if (this.selectedRows2.length > 0) {
        // let autoid = this.selectedRows2.map(item => item.autoid).join()
        _that.$refs.asncodeprint.toBatchPrint(_that.asnInfo.ccode, cinvcode, _that.selectedRows2)
      } else {
        this.$message.error('至少选择1条数据进行打印')
      }
    },
    moment,
    toPreview(record, index) {
      this.$refs.preview.toPreview(record, index)
    },
    displayName(record) {
      if (record.files.length > 0) {
        let filename = record.files.map(item => item.filename).join()
        return filename
      } else {
        return '上传'
      }
    },
    uploadData(fileids, index, fileList) {
      const newD = [...this.dataSource]
      newD[index]['fileids'] = fileids
      newD[index]['files'] = fileList
      console.log('newD', newD)
      debugger
      this.dataSource = newD

      // 直接提交
      this.toSave({ close: false })
    },
    handleChange(value, record, column, index) {
      const _that = this
      const newData = [...this.dataSource]
      if (column === 'iquantity') {
        if (_that.isCddfh) {
          let finexcess = newData[index]['finexcess'] ? Number(newData[index]['finexcess']) : 0
          //finexcess 超量
          // maxNum本次最大发货数量
          // ipoquantity订单数量
          let maxNum =
            newData[index]['ipoquantity'] * (1 + finexcess) - (Number(newData[index]['asnedquantity']) - Number((newData[index]&&newData[index]['fporefusequantity']?newData[index]['fporefusequantity']:0)))+(Number((newData[index]&&newData[index]['fporetquantity']?newData[index]['fporetquantity']:0)))

          if (value > maxNum) {
            newData[index]['iquantity'] = newData[index]['foutquantity']
            _that.$message.warning('本次发货数量允许超过待发货数量但不允许超过入库超额上限！')
            // dfhsl 待发货数量
          } else {
            newData[index]['iquantity'] = value
          }
        } else {
          if (value > newData[index]['foutquantity']) {
            _that.$message.warning('累计发货数量大于订单数量，请重新输入!')
            newData[index]['iquantity'] = newData[index]['foutquantity']
          } else {
            newData[index]['iquantity'] = value
          }
        }
      }
      if (column === 'dpdate') {
        newData[index]['dpdate'] = moment(value).format('YYYY-MM-DD')
      } else {
        newData[index][column] = value
      }
      _that.dataSource = newData
    },
    // 原来老方法
    //    handleChange(value, record, column, index) {
    //   const _that = this
    //   const newData = [...this.dataSource]
    //   const target1 = newData[index]
    //   if (column === 'iquantity') {
    //     if (value > record.dfhsl) {
    //       _that.$message.warning('累计发货数量大于订单数量，请重新输入!')
    //       value = record.dfhsl
    //     }
    //   }
    //   if (column === 'dpdate') {
    //     value = moment(value).format('YYYY-MM-DD')
    //   }
    //   if (target1) {
    //     target1[column] = value
    //     _that.dataSource = newData
    //   }
    // },
    date2string(df) {
      if (df) {
        return moment(df).format('YYYY-MM-DD')
      } else {
        return ''
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      const that = this
      that.selectedRowKeys = selectedRowKeys
      that.selectedRows = selectedRows
    },
    onSelectChange2(selectedRowKeys, selectedRows) {
      const that = this
      that.selectedRowKeys2 = selectedRowKeys
      that.selectedRows2 = selectedRows
    },
    toGetCode() {
      const _that = this
      if (_that.selectedRows.length == 1) {
        _that.$refs.asncode.toGetCode(_that.formData.ccode, _that.selectedRows)
      } else {
        _that.$message.warning('请先选择一条表体行数据!')
      }
    },
    // toPrintCode() {
    //   if (_that.selectedRows.length == 1) {
    //     _that.$refs.asncode.toGetCode(_that.formData.ccode, _that.selectedRows[0])
    //   } else {
    //     _that.$message.warning('请先选择一条表体行数据!')
    //   }
    // },
    toQuery() {
      this.selectedRows = []
      this.selectedRowKeys = []
    },
    // 原来打印功能
    toPrintCode() {
      const _that = this
      let cinvcode = ''
      _that.dataSource.map(curr => {
        cinvcode = cinvcode + curr.cinvcode + ','
      })
      if (this.selectedRows.length > 0) {
        let autoid = this.selectedRows.map(item => item.autoid).join()
        _that.$refs.asncodeprint.toPrintCode(_that.formData.ccode, cinvcode, autoid)
      } else {
        _that.$message.error('至少选择1条数据进行打印!')
      }
    },
    // 打印单据
    toPrint() {
      const _that = this
      if (_that.issaved) {
        const main = JSON.parse(JSON.stringify(_that.formData))
        delete main.ufts
        main['ddate'] = _that.date2string(main['ddate'])
        main['darrivdate'] = _that.date2string(main['darrivdate'])
        main['dshipdate'] = _that.date2string(main['dshipdate'])
        const detail = JSON.parse(JSON.stringify(_that.dataSource))
        detail.map(currv => {
          delete currv.ufts
        })
        let autoids = _that.dataSource.map(item => item.autoid).join()
        needUpload({ cvencode: _that.formData.cvencode, autoids }).then(res2 => {
          if (res2.code == 0) {
            const data = { data: { Master: [main], Detail: detail }, dtf: 'asn' }
            utoPrint('', data)
          } else {
            _that.$message.error(res2.msg ? res2.msg : '打印不成功！')
          }
        })
      } else {
        _that.$message.warning('该单据尚未保存,请保存后再打印!')
      }
    },
    toGiveUp() {
      const _that = this
      if (_that.issaved) {
        _that.reset()
        _that.visible = false
      } else {
        _that.$confirm({
          title: '单据尚未保存,确认放弃保存单据?',
          onOk() {
            _that.reset()
            _that.visible = false
          }
        })
      }
    },
    reset() {
      const that = this
      that.dataSource = []
      that.form.resetFields()
    },
    toSave(option) {
      const _that = this
      if (!_that.issaved) {
        _that.$message.warning('单据已保存，请勿重复提交!')
      } else {
        _that.form.validateFields((err, values) => {
          if (!err) {
            if (_that.dataSource.length > 0) {
              for (var i = 0; i < _that.dataSource.length; i++) {
                if (_that.dataSource[i].iinvexchrate != null && _that.dataSource[i].iinvexchrate > 0) {
                  if (!_that.dataSource[i].iarrqty) {
                    _that.dataSource[i].farrnum = 0
                  } else {
                    _that.dataSource[i].farrnum = (Number(_that.dataSource[i].iarrqty) / Number(_that.dataSource[i].iinvexchrate)).toFixed(2) //累计到货件数farrnum
                  }
                  if (!_that.dataSource[i].wdhsl) {
                    _that.dataSource[i].wdhnum = 0
                  } else {
                    _that.dataSource[i].wdhnum = (Number(_that.dataSource[i].wdhsl) / Number(_that.dataSource[i].iinvexchrate)).toFixed(2) //未到货件数wdhnum
                  }
                  if (!_that.dataSource[i].dfhsl) {
                    _that.dataSource[i].foutnum = 0
                  } else {
                    _that.dataSource[i].foutnum = (Number(_that.dataSource[i].dfhsl) / Number(_that.dataSource[i].iinvexchrate)).toFixed(2) //待发货件数foutnum
                  }
                  if (!_that.dataSource[i].iquantity) {
                    _that.dataSource[i].inum = 0
                  } else {
                    _that.dataSource[i].inum = (Number(_that.dataSource[i].iquantity) / Number(_that.dataSource[i].iinvexchrate)).toFixed(2) //本次发货件数inum
                  }
                } else {
                  _that.dataSource[i].farrnum = 0
                  _that.dataSource[i].wdhnum = 0
                  _that.dataSource[i].foutnum = 0
                  _that.dataSource[i].isendnum = 0
                }
              }
              const detail = JSON.parse(JSON.stringify(_that.dataSource))
              values['ddate'] = _that.date2string(values['ddate'])
              values['darridate'] = _that.date2string(values['darridate'])
              values['dshipdate'] = _that.date2string(values['dshipdate'])
              values['details'] = JSON.stringify(detail)
              // 删行
              // const autoids = _that.selectedRowKeys.join()
              // values['selectedRowKeys'] = autoids
              debugger
              updateAsnInfo(values)
                .then(res => {
                  if (res.code === 0 || res.code === '0') {
                    if (option.close == false) {
                      _that.visible = true
                    } else {
                      _that.visible = false
                    }
                    // _that.visible = false
                    _that.$emit('Succ')
                    _that.$message.success('保存成功')
                  } else {
                    _that.$message.error(res.msg)
                  }
                })
                .catch(function() {
                  _that.$message.error('保存失败!')
                })
            } else {
              _that.$message.warning('请选择填写表体数据信息！')
            }
          }
        })
      }
    },
    // 删除单据
    toDeleteASN() {
      const _that = this
      if (_that.id) {
        deleteAsnMain({ id: _that.id })
          .then(res => {
            if (res.code === 0 || res.code === '0') {
              _that.visible = false
              _that.$emit('Succ')
              _that.$message.success('删除成功!')
            } else {
              _that.$message.error(res.msg)
            }
          })
          .catch(function() {
            _that.$message.error('获取ASN单信息发生异常!')
          })
      } else {
        _that.$message.error('未获取到ASN单信息!')
      }
    },
    // toDelete(record, index) {
    //   const that = this
    //   if (that.selectedRowKeys.length > 0) {
    //     const length1 = Number(that.dataSource.length) - Number(that.selectedRows.length)
    //     if (length1 < 1) {
    //       that.$message.error('最少保留一行表体数据!')
    //       that.selectedRowKeys = []
    //       return
    //     } else {
    //       const target = that.dataSource.filter(item => {
    //         let flag = true
    //         that.selectedRowKeys.filter(c => {
    //           if (c === item.autoid) {
    //             flag = false
    //           }
    //         })
    //         return flag
    //       })
    //       console.log('selectedRowKeys', that.selectedRowKeys)
    //       that.dataSource = target
    //     }
    //   } else {
    //     that.$message.warning('请先选择需要删除的行!')
    //   }
    // },
    // 删除表头明细行
    toDelete(record, index) {
      const that = this
      if (this.dataSource.length == 1) {
        that.$message.error('最少保留一行表体数据!')
        return
      } else {
        delRowASN({ selectedRowKeys: record.autoid })
          .then(res => {
            if (res.code == 0) {
              that.toDetail(that.ccode)
              that.$message.success('删除成功！')
              // that.$emit('Succ')
            } else {
              that.$message.error(res.msg ? res.msg : '删除失败，请联系管理员')
            }
          })
          .catch(() => {
            that.$message.error('删除失败，请重试！')
          })
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleOk() {
      this.visible = false
    },
    // 刷新表头表格
    refesh() {
      const that = this
      getASNByCCode({ ccode: this.ccode }).then(res => {
        if (res.code === 0 || res.code === '0') {
          that.dataSource = res.body
        } else {
          that.$message.error(res.msg)
        }
      })
    },
    toDetail(ccode,type) {
      console.log(type,'22222222222')

      const _that = this
      _that.visible = true
      _that.type = type
      this.ccode = ccode
      _that.dataSource = []
      _that.selectedRows = []
      _that.selectedRowKeys = []
      this.queryUrl2 = ''
      this.isEdit = false
      _that.isdetail = true
      getASNByCCode({ ccode: ccode })
        .then(res => {
          if (res.code === 0 || res.code === '0') {
            _that.dataSource = res.body ? res.body : []
            _that.loadMainForm(res.head)
            _that.asnInfo = res.head
          } else {
            _that.$message.error(res.msg)
          }
        })
        .catch(function() {
          _that.$message.error('获取ASN单信息发生异常!')
        })
    },
    loadMainForm(formData) {
      const _that = this
      _that.formData = formData
      if (formData.iasnflag === '未生单') {
        _that.isAsnFlag = true
      } else {
        _that.isAsnFlag = false
      }
      _that.id = formData.id
      _that.form.resetFields()
      _that.$nextTick(() => {
        _that.form.setFieldsValue({
          id: formData.id,
          ccode: formData.ccode,
          cvencode: formData.cvencode,
          cvenname: formData.cvenabbname,
          ddate: moment(),
          cbustype: formData.cbustype,
          carrivalplace: formData.carrivalplace,
          cscname: formData.cscname,
          csccode: formData.csccode,
          darridate: formData.darridate ? _that.string2date(formData.darridate) : _that.string2date(formData.darridate),
          dshipdate: formData.dshipdate ? _that.string2date(formData.dshipdate) : _that.string2date(formData.dplandate),
          cmemo: formData.cmemo,
          cexch_name: formData.cexch_name,
          cptcode: formData.cptcode,
          iexchrate: formData.iexchrate,
          itaxrate: formData.itaxrate,
          cdepcode: formData.cdepcode,
          asnperson: formData.asnperson,
          asnphone: formData.asnphone,
          cpersoncode: formData.cpersoncode
        })
      })
      if (_that.isdetail) {
        _that.issaved = true
      } else {
        _that.issaved = false
      }
    },
    string2date(df) {
      if (df) {
        return moment(df)
      } else {
        return undefined
      }
    }
  }
}
</script>
